module.exports = __webpack_public_path__ + "assets/img/Lunds_universitet_white.d5f61736.svg";